export default __webpack_public_path__ + "static/media/headshot2021.7a8310a8.jpg";